import React, { useState } from 'react';
import { Form, Button, List, Input } from 'semantic-ui-react';
import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
  addUrl: {
    id: 'Add URL',
    defaultMessage: 'Add URL',
  },
  urlLabel: {
    id: 'URL',
    defaultMessage: 'URL',
  },
  titleLabel: {
    id: 'Title/Description',
    defaultMessage: 'Title/Description',
  },
  invalidUrl: {
    id: 'Invalid URL',
    defaultMessage: 'Please enter a valid URL (e.g., https://www.example.com)',
  },
  placeholder: {
    id: 'Enter URL',
    defaultMessage: 'Enter URL (e.g., https://www.example.com)',
  },
  titlePlaceholder: {
    id: 'Enter title or description',
    defaultMessage: 'Enter a title or description for this resource',
  },
});

const PersonalUrlsWidget = (props) => {
  const intl = useIntl();
  const [newUrl, setNewUrl] = useState('');
  const [newTitle, setNewTitle] = useState('');
  const [error, setError] = useState('');

  const isValidUrl = (url) => {
    try {
      new URL(url);
      return true;
    } catch (e) {
      return false;
    }
  };

  const handleAddUrl = () => {
    if (!isValidUrl(newUrl)) {
      setError(intl.formatMessage(messages.invalidUrl));
      return;
    }

    if (!newTitle.trim()) {
      setError(intl.formatMessage(messages.titlePlaceholder));
      return;
    }

    const urls = Array.isArray(props.value) ? props.value : [];
    const newEntry = { url: newUrl, title: newTitle };
    
    // Check for duplicates
    if (!urls.some(item => item.url === newUrl)) {
      props.onChange(props.id, [...urls, newEntry]);
      setNewUrl('');
      setNewTitle('');
      setError('');
    }
  };

  const handleRemoveUrl = (urlToRemove) => {
    const urls = Array.isArray(props.value) ? props.value : [];
    props.onChange(props.id, urls.filter(item => item.url !== urlToRemove));
  };

  return (
    <div className="personal-urls-widget">
      <style>
        {`
          .personal-urls-widget .url-input-group {
            display: flex;
            flex-direction: column;
            gap: 1em;
            margin-bottom: 1em;
          }
          .personal-urls-widget .url-input-group .field {
            flex: 1;
            margin: 0;
          }
          .personal-urls-widget .url-list {
            margin-top: 1em;
          }
          .personal-urls-widget .url-list-item {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0.5em;
            background: #f9f9f9;
            border-radius: 4px;
            margin-bottom: 0.5em;
          }
          .personal-urls-widget .url-list-item .content {
            flex: 1;
            margin-right: 1em;
          }
          .personal-urls-widget .url-list-item .header {
            font-weight: bold;
            margin-bottom: 0.25em;
          }
          .personal-urls-widget .url-list-item .description {
            color: #666;
            font-size: 0.9em;
          }
          .personal-urls-widget .error-message {
            color: #db2828;
            margin-top: 0.5em;
          }
        `}
      </style>
      <div className="url-input-group">
        <Form.Field>
          <Input
            type="url"
            value={newUrl}
            onChange={(e) => setNewUrl(e.target.value)}
            placeholder={intl.formatMessage(messages.placeholder)}
            error={!!error}
          />
        </Form.Field>
        <Form.Field>
          <Input
            type="text"
            value={newTitle}
            onChange={(e) => setNewTitle(e.target.value)}
            placeholder={intl.formatMessage(messages.titlePlaceholder)}
            error={!!error}
          />
        </Form.Field>
        <Button primary onClick={handleAddUrl}>{intl.formatMessage(messages.addUrl)}</Button>
      </div>
      {error && <div className="error-message">{error}</div>}
      <List className="url-list">
        {Array.isArray(props.value) && props.value.map((item, index) => (
          <List.Item key={index} className="url-list-item">
            <List.Content>
              <List.Header>{item.title}</List.Header>
              <List.Description>
                <a href={item.url} target="_blank" rel="noopener noreferrer">
                  {item.url}
                </a>
              </List.Description>
            </List.Content>
            <Button icon="trash" onClick={() => handleRemoveUrl(item.url)} />
          </List.Item>
        ))}
      </List>
    </div>
  );
};

export default PersonalUrlsWidget;
